import React, { useState } from "react";
import { ArrowPathIcon, GlobeAsiaAustraliaIcon, SparklesIcon, MapIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import "./Certifications.css";

const certifications = [
  {
    id: 1,
    title: "Spatial Data Science: The New Frontier in Analytics",
    provider: "Esri",
    type: "MOOC",
    category: "GIS & Remote Sensing",
    categoryColor: "#3A6EA5",
    description: "An advanced MOOC covering the intersection of spatial data science and geospatial analytics � including machine learning applied to geographic data, spatial statistics, and big data geospatial workflows.",
    skills: ["Spatial Statistics", "Machine Learning", "GeoPandas", "ArcGIS", "Python"],
    issuer: "Esri (MOOC)",
    badge: <GlobeAsiaAustraliaIcon width={42} height={42} strokeWidth={1.5} />,
  },
  {
    id: 2,
    title: "Career Essentials in Generative AI",
    provider: "Microsoft & LinkedIn",
    type: "Professional Certificate",
    category: "Generative AI / NLP",
    categoryColor: "#7B2D8B",
    description: "A professional certificate program covering the fundamentals of Generative AI, including large language models, prompt engineering, responsible AI practices, and practical GenAI application development.",
    skills: ["Generative AI", "LLMs", "Prompt Engineering", "Responsible AI", "NLP"],
    issuer: "Microsoft & LinkedIn Learning",
    badge: <SparklesIcon width={42} height={42} strokeWidth={1.5} />,
  },
  {
    id: 3,
    title: "Satellite Data for Air Quality, Environmental Justice & Equity Applications",
    provider: "NASA ARSET",
    type: "Applied Remote Sensing Training",
    category: "Remote Sensing",
    categoryColor: "#1B8A3A",
    description: "Part of NASA's Applied Remote Sensing Training (ARSET) program. Covers the use of satellite remote sensing data for monitoring air quality, analyzing environmental justice and equity in terms of pollution exposure, and supporting evidence-based policy.",
    skills: ["NASA ARSET", "Air Quality Monitoring", "Remote Sensing", "Environmental Analysis", "Satellite Data"],
    issuer: "NASA ARSET",
    badge: <GlobeAsiaAustraliaIcon width={42} height={42} strokeWidth={1.5} />,
  },
  {
    id: 4,
    title: "Crop Mapping using SAR and Optical Remote Sensing",
    provider: "NASA ARSET",
    type: "Applied Remote Sensing Training",
    category: "Remote Sensing",
    categoryColor: "#1B8A3A",
    description: "Part of NASA's Applied Remote Sensing Training (ARSET) program. Focuses on agricultural mapping using a combination of Synthetic Aperture Radar (SAR) and optical satellite data for crop type classification and agricultural monitoring.",
    skills: ["SAR", "Optical Remote Sensing", "Crop Mapping", "Google Earth Engine", "Agriculture AI"],
    issuer: "NASA ARSET",
    badge: <MapIcon width={42} height={42} strokeWidth={1.5} />,
  },
];

function CertificationCard({ cert }) {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      className={"cert-card" + (flipped ? " flipped" : "")}
      onClick={() => setFlipped(function (f) { return !f; })}
      role="button"
      aria-label={"View details for " + cert.title}
    >
      <div className="cert-card-inner">
        <div className="cert-front">
          <div className="cert-badge-area">
            <span className="cert-badge-emoji">{cert.badge}</span>
            <span
              className="cert-category-tag"
              style={{ color: cert.categoryColor, borderColor: cert.categoryColor, background: cert.categoryColor + "18" }}
            >
              {cert.category}
            </span>
          </div>
          <div className="cert-body">
            <span className="cert-type">{cert.type}</span>
            <h3 className="cert-title">{cert.title}</h3>
            <p className="cert-provider">{cert.provider}</p>
          </div>
          <div className="cert-footer">
            <span className="cert-flip-hint" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <ArrowPathIcon width={14} height={14} /> Click to see details
            </span>
          </div>
        </div>

        <div className="cert-back">
          <div className="cert-back-header">
            <span className="cert-badge-emoji small">{cert.badge}</span>
            <h3 className="cert-back-title">{cert.title}</h3>
          </div>
          <p className="cert-description">{cert.description}</p>
          <div className="cert-skills">
            <span className="cert-skills-label">Skills covered</span>
            <div className="cert-skill-tags">
              {cert.skills.map(function (s, i) {
                return <span key={i} className="cert-skill-tag">{s}</span>;
              })}
            </div>
          </div>
          <p className="cert-issuer">Issued by: <strong>{cert.issuer}</strong></p>
          <span className="cert-flip-hint" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <ArrowPathIcon width={14} height={14} /> Click to go back
          </span>
        </div>
      </div>
    </div>
  );
}

function Certifications() {
  return (
    <section className="certifications">
      <div className="cert-container">
        <div className="cert-header">
          <h1>Certifications</h1>
          <p>Continuing education and professional development</p>
          <div className="cert-header-decoration"></div>
        </div>

        <div className="cert-grid">
          {certifications.map(function (cert) {
            return <CertificationCard key={cert.id} cert={cert} />;
          })}
        </div>

        <p className="cert-hint" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
          <InformationCircleIcon width={18} height={18} /> This page is still in development phase.
        </p>
      </div>
    </section>
  );
}

export default Certifications;
